import React, {forwardRef, useEffect, useState} from "react";
import DataGrid, {DataGridExportInfo, DataGridProps} from "../../../packages/data-grid";
import DataGridController from "../../../packages/data-grid/core/models/in-app/controller";
import PartnerDataGridLoadingComponent from './loading-component'
import useIsMounted from '../../hooks/use-is-mounted';
import classnames from "classnames";


const _PartnerDataGrid: React.ForwardRefRenderFunction<DataGridController, DataGridProps>
    = ({
           LoadingComponent = <PartnerDataGridLoadingComponent/>,
           getExportInfo: getExportInfoProps,
           ...props
       }, ref) => {
    const [exporting, setExporting] = useState(false);
    const isMounted = useIsMounted();

    /**
     * With each change in the exporting value of the state:
     * - opens or closes the exporting dialog of the application.
     */
    useEffect(() => {
        if (exporting) {
            window.partner?.openExportingDialog?.();
        } else {
            window.partner?.closeExportingDialog?.();
        }
    }, [exporting])


    /**
     * Fetches the exported information of the data-grid.
     *
     * * sets the [exporting] state value to open or close the exporting dialog.
     */
    const getExportInfo = async (): Promise<DataGridExportInfo | undefined> => {
        if (!getExportInfoProps)
            return;
        setExporting(true);
        const data = await getExportInfoProps();
        if (!isMounted())
            return;
        setExporting(false);
        return data;
    }

    return (
        <>
            {/*@ts-ignore*/}
            <DataGrid
                LoadingComponent={LoadingComponent}
                getExportInfo={!getExportInfoProps ? undefined : getExportInfo}
                {...props}
                version={props.version}
                name={props.name}
                classNames={{
                    ...props?.classNames ?? {},
                    container: classnames('partner-data-grid-container', props.classNames?.container),
                }}
                ref={ref}
            />
        </>
    );
};

const PartnerDataGrid = forwardRef(_PartnerDataGrid);

export * from '../../../packages/data-grid/models';
export {DataGridProvider, useDataGridSavedState, dataGridCellTextProps} from '../../../packages/data-grid'
export default PartnerDataGrid;
